import { z } from 'zod';
import { LocaleSchema } from './locale.js';
export const DISPLAY_NAME_MAX_LENGTH = 80;
/** A person's chosen name: trimmed, single line, 1–80 characters. */
export const DisplayNameSchema = z
    .string()
    .trim()
    .min(1, 'Enter your name')
    .max(DISPLAY_NAME_MAX_LENGTH, `Use ${DISPLAY_NAME_MAX_LENGTH} characters or fewer`)
    .regex(/^\P{Cc}*$/u, 'Keep your name on one line');
/** The signed-in person's own account details (not organisation-scoped). */
export const UserProfileSchema = z.object({
    userId: z.string().min(1),
    email: z.string().email(),
    displayName: z.string().nullable(),
    /** Null until chosen, or when a stored language is no longer offered. */
    locale: LocaleSchema.nullable().catch(null),
});
export const UpdateUserProfileRequestSchema = z
    .object({
    displayName: DisplayNameSchema.optional(),
    locale: LocaleSchema.optional(),
})
    .refine((body) => body.displayName !== undefined || body.locale !== undefined, {
    message: 'Provide displayName or locale',
});
//# sourceMappingURL=profile.js.map